import { TradeSkeleton } from './TradeSkeleton';
import { TradeSkeletonWithSavings } from './TradeSkeletonWithSavings';

const TradeSkeletons = {
  TradeSkeleton,
  TradeSkeletonWithSavings,
};

export { TradeSkeletons };
